const threshold = 0.5

export interface VirtualizeParams {
  perPage: number
  positionToRow: (top: number) => number
  rowToPosition: (ix: number) => number
  containerHeight: (rows: number, from: number, to: number) => number
}

export const prepareVirtualize = (
  scrollTop: number,
  windowHeight: number,
  rowCount: number,
  virtualize: VirtualizeParams
): {fromRow: number; toRow: number; height: number} => {
  const perPage = virtualize.perPage

  const topRow = virtualize.positionToRow(scrollTop)
  let fromPage = Math.floor(topRow / perPage)
  const deltaTop = topRow - fromPage * perPage
  if (deltaTop < perPage * threshold) {
    fromPage -= 1
  }
  const fromRow = Math.max(fromPage * perPage, 0)

  const bottomRow = virtualize.positionToRow(scrollTop + windowHeight) + 1
  let toPage = Math.ceil(bottomRow / perPage)
  const deltaBottom = toPage * perPage - bottomRow
  if (deltaBottom < perPage * threshold) {
    toPage += 1
  }
  const toRow = Math.min(toPage * perPage, rowCount)

  const height = virtualize.containerHeight(rowCount, fromRow, toRow)

  return {fromRow, toRow, height}
}
